import { render } from "./Samples.vue?vue&type=template&id=11ae1874&scoped=true"
import script from "./Samples.vue?vue&type=script&lang=js"
export * from "./Samples.vue?vue&type=script&lang=js"

import "./Samples.vue?vue&type=style&index=0&id=11ae1874&scoped=true&lang=css"

import exportComponent from "/builds/dlr-pt/rote-liste-zentrum/pwa-kartierung/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11ae1874"]])

export default __exports__